import apiClient from '@/utils/request'
import {
  IAutomationsResponse,
  IAutomationResponse,
  IAutomationCreatePayload,
  IAutomationUpdatePayload,
  IAutomationEventOption,
  IAutomationEventSettingPayload,
  IAutomationEventSettingsResponse
} from '@/interfaces/automations'

export const fetchItems = async (): Promise<IAutomationsResponse> => {
  const response = await apiClient.get<IAutomationsResponse>('/automations')
  return response.data
}

export const fetchItem = async (id: string): Promise<IAutomationResponse> => {
  const response = await apiClient.get<IAutomationResponse>(
    `/automations/${id}`
  )
  return response.data
}

export const createAutomation = async (
  automation: IAutomationCreatePayload
): Promise<IAutomationResponse> => {
  const response = await apiClient.post<IAutomationResponse>(
    '/automations',
    automation
  )
  return response.data
}

export const updateAutomation = async (
  automation: IAutomationUpdatePayload
): Promise<IAutomationResponse> => {
  const response = await apiClient.put<IAutomationResponse>(
    `/automations/${automation.id}`,
    automation
  )
  return response.data
}

export const deleteAutomation = async (id: string) => {
  await apiClient.delete(`/automations/${id}`)
}

export const disableDefaultAutomation = async (id: string) => {
  await apiClient.post(`/automations/${id}/disable_default`)
}

export const fetchEvents = async (): Promise<IAutomationEventOption[]> => {
  const response = await apiClient.get<IAutomationEventOption[]>(
    '/automations/events'
  )
  return response.data
}

export const fetchEventSettings = async (
  payload: IAutomationEventSettingPayload
): Promise<IAutomationEventSettingsResponse> => {
  const response = await apiClient.get<IAutomationEventSettingsResponse>(
    '/automations/event_settings',
    {
      params: { event_type: payload.event_type }
    }
  )
  return response.data
}
